import React from "react";
import { ReactTyped } from "react-typed";
import "./Hero.css";

function Hero() {
    const scrollToProductList = () => {
        const productListSection = document.getElementById("productlist");
        if (productListSection) {
            const offset = -50;
            const position =
                productListSection.getBoundingClientRect().top + window.scrollY + offset;
            window.scrollTo({ top: position, behavior: "smooth" });
        }
    };

    return (
        <section className="hero" id="home">
            {/* Video Background - Full Screen */}
            <div className="video-wrapper">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="hero-video"
                    disablePictureInPicture
                >
                    <source src="/assets/videos/large.mp4" type="video/mp4" />
                    <source src="/assets/videos/small.mp4" type="video/mp4" media="(max-width: 768px)" />
                    Your browser does not support the video tag.
                </video>
            </div>

            {/* Responsive Typed Text */}
            <h1 className="typed-heading">
                <ReactTyped
                    strings={[
                        '<span class="line1">Grace in gold</span>',
                        '<span class="line2">Shine with elegance</span>',
                        '<span class="line3">Jewels of perfection</span>',
                    ]}
                    typeSpeed={60}
                    backSpeed={30}
                    loop
                />
            </h1>

            {/* Shop Now Button */}
            <div className="shop-btn-wrapper">
                <button className="shop-btn" onClick={scrollToProductList}>
                    Shop Now
                </button>
            </div>
        </section>
    );
}

export default Hero;